import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomerModel} from "../../order-to-cash/models-otc/customer-model";
import {AgronimistModel} from "../../models/lab-manager/agronimist";
import {BasicLabManagerItemModel} from "../../models/lab-manager/basic-lab-manager-item";
import {LabSubmissionDetailsModel} from "../../models/lab-manager/lab-submission-details";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {LabManagerService} from "../lab-manager.service";
import {LAB_MANAGER_DATE_FORMAT} from "../lab-samples/lab-samples.component";

export interface LabSubmissionDetailsChangeModel  {
  labSubmissionDetails: LabSubmissionDetailsModel;
  isValid: boolean;
}

@Component({
    selector: 'app-lab-submission-detail',
    templateUrl: './lab-submission-detail.component.html',
    styleUrls: ['./lab-submission-detail.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: LAB_MANAGER_DATE_FORMAT }
    ],
    standalone: false
})
export class LabSubmissionDetailComponent implements OnInit, OnChanges{

  submissionDetailsForm: FormGroup;
  @Input() customerList: CustomerModel[] = [];
  @Input() isLoadingCustomers: boolean = true;
  @Input() submissionTypes: BasicLabManagerItemModel[] = [];
  capturingChanges: boolean = true;
  @Input() creationDate: string = '';
  currentDate = new Date();
  selectedCustomer: CustomerModel = null;
  representative: any = JSON.parse(sessionStorage.getItem('representative'));
  @Input() agronomistList: AgronimistModel[] = [];
  @Input() labList: BasicLabManagerItemModel[] = [];
  @Input() labSubmissionDetails: LabSubmissionDetailsModel = null;
  @Output() labSubmissionChanges: EventEmitter<LabSubmissionDetailsChangeModel> = new EventEmitter<LabSubmissionDetailsChangeModel>();
  @Output() customerChange: EventEmitter<CustomerModel> = new EventEmitter<CustomerModel>();
  filteredAgronomistList: AgronimistModel[] = [];
  @Input() hasOneAnalysis: boolean = false;
  @Input() hasOneSample: boolean = false;
  @Input() labHasSamples: boolean = false;
  agronomistFilterCtrl: FormControl<string> = new FormControl<string>('');
  filteredClientList: CustomerModel[] = [];
  clientFilterCtrl: FormControl<string> = new FormControl<string>('');
  filteredPayerList: CustomerModel[] = [];
  disableInputs: boolean = false;
  payerFilterCtrl: FormControl<string> = new FormControl<string>('');


  // formHeight: string = (window.innerHeight - 340) + 'px';

  // @HostListener('window:resize', ['$event'])
  // onResize() {
  //   this.formHeight = (window.innerHeight - 340) + 'px';
  // }


  constructor(
      private labManagerService: LabManagerService
  ) {
    this.submissionDetailsForm = new FormGroup({
      agronomistUserId: new FormControl(null, [Validators.required]),
      labManLabId: new FormControl(null, [Validators.required]),
      agentLabRef: new FormControl(null),
      otcCustomerDetailId: new FormControl(null, [Validators.required]),
      contactPerson: new FormControl(null),
      contactNumber: new FormControl(null),
      orderAccountId: new FormControl(null, [Validators.required]),
      coopNo: new FormControl(null),
      orderDate: new FormControl(null),
      courier: new FormControl(null),
      waybillNumber: new FormControl(null),
      note: new FormControl(null)
    });

    this.captureFormInputs();
  }
  ngOnInit(): void {
    if(localStorage.getItem('firstTimeLogin')) {
      localStorage.removeItem('firstTimeLogin');
    }
    this.agronomistFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredAgronomistList = [...this.agronomistList.filter(a => {
          return a.userIdName.toLowerCase().includes(res.toLowerCase()) || a.userIdSurname.toLowerCase().includes(res.toLowerCase())
        })]
      }
    });

    this.clientFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredClientList = this.filterCustomerList(res);
      }
    });

    this.payerFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredPayerList = this.filterCustomerList(res);
      }
    });
  }

  filterCustomerList(search: string): CustomerModel[] {
    return [...this.customerList.filter(c => c.name.toLowerCase().includes(search.toLowerCase()))];
  }

  checkCoOp(payer) {
    // console.log(payer)
    // console.log(this.submissionDetailsForm.get('orderAccountId').value)
  }

  clientDetailChanged() {
    let clientId = this.submissionDetailsForm.get('otcCustomerDetailId').value;
    if(!this.submissionDetailsForm.get('orderAccountId').value) {
      this.submissionDetailsForm.get('orderAccountId').setValue(clientId);
    }
    this.selectedCustomer = this.customerList.find(c => c.id === clientId);
    this.customerChange.emit(this.selectedCustomer);
  }

  captureFormInputs() {
    // Subscribe to form status changes
    this.submissionDetailsForm.valueChanges.subscribe(status => {
      this.labSubmissionDetails = {...this.labSubmissionDetails, ...this.submissionDetailsForm.value};
      this.labSubmissionChanges.emit({
        labSubmissionDetails: this.labSubmissionDetails,
        isValid: this.submissionDetailsForm.valid
      });
      // const formData = {...this.submissionDetailsForm.value, creationDate: this.creationDate};
      // this.labManagerSharedDataService.updateLabSubmissionDetails(formData);
    });
  }

  checkPayerType() {
    if(this.submissionDetailsForm?.get('orderAccountId')?.value && this.customerList?.length > 0) {
      let selectedCustomer = this.customerList.find(c => c.id === this.submissionDetailsForm?.get('orderAccountId')?.value);
      if(selectedCustomer?.sGrp === 'ZAF') {
        return true;
      }
    }

    return false;
  }

  setSelectedCustomerList() {
    if(this.customerList?.length > 0 && this.submissionDetailsForm.value.otcCustomerDetailId) {
      let index = this.customerList.findIndex(c => c.id === this.submissionDetailsForm.value.otcCustomerDetailId);

      if(index !== -1) {
        this.selectedCustomer = this.customerList[index];
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.agronomistList?.currentValue) {
      this.filteredAgronomistList = [...this.agronomistList];
    }

    if(changes?.customerList?.currentValue) {
      this.filteredClientList = [...this.customerList];
      this.filteredPayerList = [...this.customerList];

      this.setSelectedCustomerList();
    }

    if(changes?.labSubmissionDetails?.currentValue && this.capturingChanges) {
      this.creationDate = changes.labSubmissionDetails.currentValue.creationDate;
      this.submissionDetailsForm.setValue({
        agronomistUserId: changes.labSubmissionDetails.currentValue.agronomistUserId,
        labManLabId: changes.labSubmissionDetails.currentValue.labManLabId,
        coopNo: changes.labSubmissionDetails.currentValue.coopNo,
        otcCustomerDetailId: changes.labSubmissionDetails.currentValue.otcCustomerDetailId,
        contactPerson: changes.labSubmissionDetails.currentValue.contactPerson,
        contactNumber: changes.labSubmissionDetails.currentValue.contactNumber,
        orderAccountId: changes.labSubmissionDetails.currentValue.orderAccountId,
        agentLabRef: changes.labSubmissionDetails.currentValue.agentLabRef,
        orderDate: changes.labSubmissionDetails.currentValue?.orderDate ?? this.creationDate,
        courier: changes.labSubmissionDetails.currentValue.courier,
        waybillNumber: changes.labSubmissionDetails.currentValue.waybillNumber,
        note: changes.labSubmissionDetails.currentValue.note
      });

      this.setSelectedCustomerList();
      this.capturingChanges = false;
    }

    if(changes?.labSubmissionDetails?.currentValue && !this.capturingChanges) {
      if(changes?.labSubmissionDetails?.currentValue?.labManStatusId >= 2) {
        if(!this.disableInputs) {
          this.submissionDetailsForm.disable({ emitEvent: false });
          this.disableInputs = true;
        }

        if(changes.labSubmissionDetails.currentValue.labManStatusId === 4) {
          this.submissionDetailsForm.controls.coopNo.enable({ emitEvent: false });
        }
      } else {
        this.submissionDetailsForm.enable();

        if(this.hasOneAnalysis) {
          this.submissionDetailsForm.controls.labManLabId.disable();
        }

        if(this.hasOneSample) {
          this.submissionDetailsForm.controls.otcCustomerDetailId.disable();
        }
      }
    }
  }



}
